import React from 'react'

import CustomerTosLink from "./CustomerTosLink";

export default function PlaceOrderButton({waiting, disabled, onClick}) {

    const text = waiting ? I18n.t('wait') : I18n.t('cart_summary.send_order');

    return (
        <div className="row separated">
            <div className="col-sm-8 col-sm-offset-2 separated">
                { disabled || waiting
                    ?  <span id="checkout-button" className="btn btn-blue btn-block btn-lg checkout-button disabled"
                             title={text}>{text}</span>
                    : <a id="checkout-button" className="btn btn-blue btn-block btn-lg checkout-button"
                         disabled={(disabled || waiting) && 'disabled'}
                         onClick={onClick}
                         title={text}>{text}</a>
                }

                <CustomerTosLink/>
            </div>
        </div>
    )
};
